var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaylink360Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 419.71 419.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        fill-rule: evenodd;\n      }\n\n      .cls-8 {\n        fill: #e43a6a;\n      }\n\n      .cls-9 {\n        fill: #fdb714;\n      }\n\n      .cls-10 {\n        fill: #fbc5b5;\n      }\n\n      .cls-3 {\n        fill: #f05323;\n      }\n\n      .cls-4 {\n        fill: #f2673a;\n      }\n\n      .cls-5 {\n        fill: #ffcd05;\n      }\n\n      .cls-6, .cls-11 {\n        fill: #bf2450;\n      }\n\n      .cls-7 {\n        fill: #feece6;\n      }\n\n      .cls-12 {\n        fill: #924646;\n      }\n\n      .cls-13 {\n        fill: #2e2024;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 209.86,
    cy: 209.86,
    r: 209.86,
    transform: "translate(-86.93 209.86) rotate(-45)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m245,267.74c8.58-4.41,23.54,4.38,33.4,19.62,9.86,15.24,10.89,31.17,2.31,35.58-8.58,4.41-23.54-4.38-33.4-19.62-9.86-15.24-10.89-31.17-2.31-35.58Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m212.57,317.94l1.72-3.68c2.57-5.5,3.71-11.55,3.3-17.61l-15.55,5.04,10.53,16.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m128.53,311.98l1.45-3.1c2.17-4.63,3.12-9.74,2.78-14.84l-13.11,4.25,8.88,13.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m63.29,124.25l-34.9-19.84C10.35,135.39,0,171.41,0,209.86c0,3.72.1,7.42.29,11.09l32.14,7.82,7.96,12.44c22.07,34.49,62.7,52.35,103.03,45.29l29.86-96.56L63.29,124.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m294.56,152.78h26.5v12.69h-26.5v-12.69h0Zm31.23,0h26.5v151.97h-26.5v-151.97Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m97.89,155.35h274.75c6.04,0,10.95,4.91,10.95,10.95v124.93c0,6.04-4.91,10.95-10.95,10.95H97.89c-6.04,0-10.95-4.91-10.95-10.95v-124.93c0-6.04,4.91-10.95,10.95-10.95Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m102.45,162.07h265.62c2.66,0,4.81,2.16,4.81,4.81v123.77c0,2.66-2.16,4.81-4.81,4.81H102.45c-2.66,0-4.81-2.16-4.81-4.81v-123.77c0-2.66,2.16-4.81,4.81-4.81Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m63.29,124.25c27.37-15.21,69.39-11.61,90.84-7.96,29.54,5.03,58.91,11.14,87.85,18.91,27.52,7.39-3.51,47.44-63.96,26.88l-42.56,7.72-7.96,4.98c-15.53,9.7-35.47,8.62-49.86-2.7-14.39-11.32-20.13-30.45-14.35-47.82Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m63.29,124.25l-11.45,18.17c-5.93,9.41-7.73,20.83-4.98,31.61l-5.72,7.35c-8.59,11.02-11.87,25.28-8.96,38.94l.75-3.73c2.88-14.41,11.39-27.09,23.64-35.21l.5-6.35c.97-12.41,8.19-23.48,19.16-29.37l-12.94-21.4Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m177.03,292.13c8.79-5.37,22.45-2.13,30.51,7.24,8.06,9.37,7.47,21.31-1.32,26.68-8.79,5.37-22.45,2.13-30.52-7.24-8.06-9.37-7.47-21.32,1.32-26.68Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m139.83,287.56c8.79-5.37,22.45-2.13,30.52,7.24,8.06,9.37,7.47,21.32-1.32,26.68-8.79,5.37-22.45,2.13-30.52-7.24-8.06-9.37-7.47-21.31,1.32-26.69Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m98.57,290.22c7.41-4.53,18.93-1.79,25.73,6.1,6.8,7.9,6.3,17.97-1.11,22.5-7.41,4.53-18.93,1.79-25.73-6.1-6.8-7.9-6.3-17.97,1.11-22.5Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m144.02,189.38h118.44c4.53,0,8.21,3.68,8.21,8.21v62.36c0,4.53-3.68,8.21-8.21,8.21h-118.44c-4.53,0-8.21-3.68-8.21-8.21v-62.36c0-4.53,3.68-8.21,8.21-8.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 135.82,
    y: 231.62,
    width: 134.85,
    height: 17.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m150.15,211.21c4.41,0,8-3.59,8-8s-3.59-8-8-8-8,3.59-8,8,3.59,8,8,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m168.57,211.21c4.41,0,8-3.59,8-8s-3.59-8-8-8-8,3.59-8,8,3.59,8,8,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m149.02,218.56h16.87c1.82,0,3.3,1.48,3.3,3.3h0c0,1.82-1.48,3.3-3.3,3.3h-16.87c-1.82,0-3.3-1.48-3.3-3.3h0c0-1.82,1.48-3.3,3.3-3.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m179.54,218.56h16.86c1.82,0,3.3,1.48,3.3,3.3h0c0,1.82-1.48,3.3-3.3,3.3h-16.86c-1.82,0-3.3-1.48-3.3-3.3h0c0-1.82,1.48-3.3,3.3-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m210.07,218.56h16.87c1.82,0,3.3,1.48,3.3,3.3h0c0,1.82-1.48,3.3-3.3,3.3h-16.87c-1.82,0-3.3-1.48-3.3-3.3h0c0-1.82,1.48-3.3,3.3-3.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m240.6,218.56h16.86c1.82,0,3.3,1.48,3.3,3.3h0c0,1.82-1.48,3.3-3.3,3.3h-16.87c-1.82,0-3.3-1.48-3.3-3.3h0c0-1.82,1.48-3.3,3.3-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m149.02,253.31h56.94c1.81,0,3.3,1.48,3.3,3.3h0c0,1.81-1.48,3.3-3.3,3.3h-56.94c-1.81,0-3.3-1.48-3.3-3.3h0c0-1.81,1.48-3.3,3.3-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m220.8,253.31h16.39c1.81,0,3.3,1.48,3.3,3.3h0c0,1.81-1.48,3.3-3.3,3.3h-16.39c-1.81,0-3.3-1.48-3.3-3.3h0c0-1.81,1.48-3.3,3.3-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m231.71,195.21h24.36c.81,0,1.47.66,1.47,1.47v12.34c0,.81-.66,1.47-1.47,1.47h-24.36c-.81,0-1.47-.66-1.47-1.47v-12.34c0-.81.66-1.47,1.47-1.47Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m329.22,212.69c4.12,4.12,6.66,9.8,6.66,16.08s-2.55,11.97-6.66,16.08l-4.16-4.16c3.05-3.05,4.94-7.27,4.94-11.92s-1.89-8.87-4.94-11.92l4.16-4.16h0Zm-16.08,6.27c5.42,0,9.81,4.39,9.81,9.81s-4.39,9.81-9.81,9.81-9.81-4.39-9.81-9.81,4.39-9.81,9.81-9.81h0Zm18.51-8.7c4.74,4.74,7.67,11.28,7.67,18.51s-2.93,13.77-7.67,18.51l4.16,4.16c5.8-5.8,9.39-13.82,9.39-22.67s-3.59-16.87-9.39-22.67l-4.16,4.16h0Zm6.59-6.59l4.16-4.16c7.49,7.49,12.12,17.83,12.12,29.25s-4.63,21.77-12.12,29.25l-4.16-4.16c6.42-6.42,10.4-15.3,10.4-25.1s-3.97-18.67-10.4-25.1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaylink360Icon);
export default __webpack_public_path__ + "static/media/paylink360icon.832562d5ed0417e94a75701789f7a0d0.svg";
export { ForwardRef as ReactComponent };